import envConfig from '../config/config';
import logger from '../utils/logger';

export async function TroubleLoggingIn(email) {
  try {
    const resp = await fetch(`${envConfig.apps.providerAccount}/v1/trouble-logging-in/${email}`, {
      method: 'POST',
    });
    const parsedResp = await resp.json();
    if (parsedResp && parsedResp.hasSSO) return parsedResp.hasSSO;
  } catch (error) {
    logger.error(error, {
      context: {
        email,
        message: 'Error submitting trouble logging in',
      },
    });
  }
}
